export default "__VITE_ASSET__rMBMbIn$__"